import React, { useState, useEffect } from "react"
import { sumBy } from "lodash"
import PropTypes from "prop-types"

// Components
import ExportMenu from "Components/ExportMenu"

// Style
import {
  CompteurItem,
  IconContainer,
  ValuesContainer,
  ValueAndPeriod,
  SeparatorBetweenComparedValues,
  Period,
  Value,
  Label,
} from "Components/chartsLibrary/Compteur/index.style"

// Utils
import { downloadScreenShotFile, getImgInPDF } from "Utils/screenshotPage"
import { getObjectToExport } from "Utils/widgetsUtils"
import { exportDatas } from "Utils/global"
import { formatNumberDisplayed } from "../utils/global.js"

const WidgetCompteur = ({
  enableExportMenu,
  fieldsData,
  dataChart,
  valueData,
  comparisonValues,
  categoryData,
  fontAlignement,
  fontColor,
  fontSize,
  fontWeight,
  labelColor,
  labelSize,
  labelWeight,
  label,
  numberDecimal,
  decimalSeparator,
  showSpaceForThousand,
  isFullScreenable,
  periodToDisplay,
  iconSelected,
  iconPosition,
  iconColor,
  iconOpacity,
  iconFontSize,
  widgetTitle,
  onSegmentClick,
  ...otherProps
}) => {
  const exportMenuId = `exportMenu${Math.random()}`
  const ID = `compteur${Math.random()}`

  const getValueToShow = (dataChart, valueDataProperty, options) => {
    if (dataChart && valueData && Array.isArray(valueData) && valueData.length >= 1) {
      //Now this sum seems useless
      //the sum is dealt by ETL
      // var value = sumBy(dataChart, valueDataProperty)
      // Fix récupération de la value du 1er objet, tous les valeurs sont le même resultat du calcul
      var value = dataChart?.length > 0 ? dataChart[0][valueDataProperty] : 0

      var numberDecimal = options?.numberDecimal
      var numberDecimalIsCorrect =
        numberDecimal !== undefined && numberDecimal >= 0 && numberDecimal <= 10

      if (value !== undefined && value !== null && numberDecimalIsCorrect) {
        value = formatNumberDisplayed(value, numberDecimal, showSpaceForThousand, decimalSeparator)
      }
      return value
    }
    return "-"
  }

  const options = {
    numberDecimal,
  }

  const showSecondValue = (dataChart, valueData) => {
    return dataChart && valueData && Array.isArray(valueData) && valueData.length >= 2
  }

  const hideElement = element => {
    element.style.display = "none"
  }

  const exportPNG = () => {
    const title = widgetTitle || label.replace(/ /g, "_")
    const exportMenu = document.getElementById(exportMenuId)
    hideElement(exportMenu)
    // take the screen and export
    downloadScreenShotFile(ID, title)
    // display again the menu
    setTimeout(() => exportMenu.removeAttribute("style"), 10) // ten milliseconds is invisible for the user
  }

  const getImgAndSaveAsPDF = () => {
    const exportMenu = document.getElementById(exportMenuId)
    const title = widgetTitle || label.replace(/ /g, "_")
    // hide the menu to not show him in the export
    exportMenu.style.display = "none"
    // take the screen and export
    getImgInPDF(ID, title)
    // display again the menu
    setTimeout(() => exportMenu.removeAttribute("style"), 10) // ten milliseconds is invisible for the user
  }

  const exportData = (fileType = "csv") => {
    if (dataChart.length) {
      const title = widgetTitle || label.replace(/ /g, "_")

      const objectToExport = {
        header: [otherProps?.widgetGroupBy?.[0]?.name],
        body: [[dataChart?.[0]?.[otherProps?.widgetGroupBy?.[0]?.valueId]]],
      }

      exportDatas(objectToExport, fileType, title)
    } else {
      alert("no datas to export")
    }
  }

  const exportMenuPosition = isFullScreenable
    ? { top: "45px", right: "20px" }
    : { top: "0px", right: "25px" }

  return (
    <>
      {enableExportMenu && (
        <ExportMenu
          exportMenuPosition={exportMenuPosition}
          exportPNG={exportPNG}
          exportCSV={() => exportData("csv")}
          exportXLSX={() => exportData("xlsx")}
          exportPDF={() => exportData("pdf")}
          exportImgPDF={getImgAndSaveAsPDF}
          exportMenuId={exportMenuId}
        />
      )}
      <CompteurItem fontAlignement={fontAlignement} id={ID}>
        <ValuesContainer id="counterValuesContainer" fontColor={fontColor}>
          {iconSelected !== "" && iconPosition === "left" && (
            <IconContainer
              iconOpacity={iconOpacity / 100}
              iconColor={iconColor}
              iconFontSize={iconFontSize}
            >
              <i className={iconSelected} />
            </IconContainer>
          )}
          <ValueAndPeriod
            fontAlignement={fontAlignement}
            hasLabel={label}
            onMouseDown={onSegmentClick ? e => e.stopPropagation() : undefined}
            onClick={onSegmentClick ? () => onSegmentClick({}) : undefined}
            style={onSegmentClick ? { cursor: "pointer" } : undefined}
          >
            {periodToDisplay[0] !== "" && <Period>{"P1 :"}</Period>}
            <Value fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeight}>
              {getValueToShow(dataChart, valueData?.[0], options)}
            </Value>
            <Label
              fontAlignement={fontAlignement}
              labelColor={labelColor}
              labelSize={labelSize}
              labelWeight={labelWeight}
            >
              {label || ""}
            </Label>
          </ValueAndPeriod>
          {iconSelected !== "" && iconPosition === "right" && (
            <IconContainer
              iconOpacity={iconOpacity / 100}
              iconColor={iconColor}
              iconFontSize={iconFontSize}
            >
              <i className={iconSelected} />
            </IconContainer>
          )}
          {showSecondValue(dataChart, valueData) && (
            <SeparatorBetweenComparedValues fontColor={fontColor} />
          )}
          {showSecondValue(dataChart, valueData) && (
            <>
              {iconSelected !== "" && iconPosition === "left" && (
                <IconContainer
                  iconOpacity={iconOpacity / 100}
                  iconColor={iconColor}
                  iconFontSize={iconFontSize}
                >
                  <i className={iconSelected} />
                </IconContainer>
              )}
              <ValueAndPeriod>
                {periodToDisplay[1] !== "" && <Period>{"P2 :"}</Period>}
                <Value fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeight}>
                  {getValueToShow(dataChart, valueData[1], options)}
                </Value>
                <Label
                  fontAlignement={fontAlignement}
                  labelColor={labelColor}
                  labelSize={labelSize}
                  labelWeight={labelWeight}
                >
                  {label || ""}
                </Label>
              </ValueAndPeriod>
              {iconSelected !== "" && iconPosition === "right" && (
                <IconContainer
                  iconOpacity={iconOpacity / 100}
                  iconColor={iconColor}
                  iconFontSize={iconFontSize}
                >
                  <i className={iconSelected} />
                </IconContainer>
              )}
            </>
          )}
        </ValuesContainer>
      </CompteurItem>
    </>
  )
}

WidgetCompteur.propTypes = {
  enableExportMenu: PropTypes.bool,
  isFullScreenable: PropTypes.bool,
  fieldsData: PropTypes.array,
  numberDecimal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showSpaceForThousand: PropTypes.bool,
  decimalSeparator: PropTypes.string,
  comparisonValues: PropTypes.object,
  periodToDisplay: PropTypes.array,
  iconSelected: PropTypes.string,
  iconPosition: PropTypes.string,
  iconColor: PropTypes.string,
  iconOpacity: PropTypes.number,
  iconFontSize: PropTypes.string,
}

WidgetCompteur.defaultProps = {
  fieldsData: [],
  enableExportMenu: false,
  numberDecimal: 2,
  showSpaceForThousand: true,
  decimalSeparator: ",",
  comparisonValues: {},
  periodToDisplay: ["", ""],
  isFullScreenable: false,
  iconSelected: "",
  iconPosition: "left",
  iconColor: "#000000",
  iconFontSize: "1rem",
  iconOpacity: 100,
}

export default WidgetCompteur
